import { render, staticRenderFns } from "./v2overview.vue?vue&type=template&id=16927fe6&"
import script from "./v2overview.vue?vue&type=script&lang=js&"
export * from "./v2overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports